<template>
  <v-row v-if="moduleName" no-gutters>
    <v-col v-if="moduleName === 'tass'" cols="12">
      <tass-student-management-config
        :key="vendorSid"
        :config="studentManagementConfig"
        :service-ended="serviceEnded"
        @update:config="onStudentManagementConfigChanged"
        @update:error-hash="onStudentManagementErrorHashChanged"
        @update:valid="onStudentManagementConfigValidChanged"
      />
    </v-col>

    <v-col v-else-if="moduleName === 'caremonkey'" cols="12">
      <operoo-student-management-config
        :key="vendorSid"
        :config="studentManagementConfig"
        :service-ended="serviceEnded"
        @update:config="onStudentManagementConfigChanged"
        @update:valid="onStudentManagementConfigValidChanged"
        @update:error-hash="onStudentManagementErrorHashChanged"
      />
    </v-col>

    <v-col v-else-if="moduleName === 'sentral-api'" cols="12">
      <sentral-api-student-management-config
        :key="vendorSid"
        :config="studentManagementConfig"
        :service-ended="serviceEnded"
        @update:config="onStudentManagementConfigChanged"
        @update:error-hash="onStudentManagementErrorHashChanged"
        @update:valid="onStudentManagementConfigValidChanged"
      />
    </v-col>

    <v-col v-else-if="moduleName === 'wonde'" cols="12">
      <wonde-student-management-config
        ref="wondeConfig"
        :key="vendorSid"
        :config="studentManagementConfig"
        :service-ended="serviceEnded"
        @update:config="onStudentManagementConfigChanged"
        @update:error-hash="onStudentManagementErrorHashChanged"
        @update:valid="onStudentManagementConfigValidChanged"
      />
    </v-col>

    <v-col v-else-if="moduleName === 'complispace'" cols="12">
      <complispace-student-management-config
        :files="studentManagementFiles"
        :service-ended="serviceEnded"
        :file-extensions="studentManagementFileExtensions"
        @file-changed="onStudentManagementFileChanged"
      />
    </v-col>
  </v-row>
</template>

<script>
import SentralApiStudentManagementConfig from './SentralApiStudentManagementConfig';
import WondeStudentManagementConfig from './WondeStudentManagementConfig';
import TassStudentManagementConfig from './TassStudentManagementConfig';
import OperooStudentManagementConfig from './OperooStudentManagementConfig';
import ComplispaceStudentManagementConfig from './ComplispaceStudentManagementConfig';

export default {
  name: 'ClientStudentManagementConfig',

  components: {
    SentralApiStudentManagementConfig,
    WondeStudentManagementConfig,
    TassStudentManagementConfig,
    OperooStudentManagementConfig,
    ComplispaceStudentManagementConfig
  },

  props: {
    moduleName: {
      type: String,
      default: ''
    },
    vendorSid: {
      type: String,
      default: null
    },
    serviceEnded: {
      type: Boolean,
      default: false
    },
    studentManagementConfig: {
      type: Object,
      default: () => ({})
    },
    studentManagementFiles: {
      type: Array,
      default: () => [{}]
    },
    studentManagementFileExtensions: {
      type: String,
      default: '.csv'
    },
    studentManagementFileMimeTypeAllowed: {
      type: Array,
      default: () => ['text/csv']
    },
    studentManagementErrorHash: {
      type: Object,
      default: () => ({})
    },
    studentManagementConfigValid: {
      type: Boolean,
      default: true
    }
  },

  emits: [
    'changed',
    'update:valid',
    'update:student-management-config',
    'update:student-management-files',
    'update:student-management-error-hash',
    'update:student-management-config-valid'
  ],

  computed: {
    isValid() {
      return (
        this.studentManagementConfigValid &&
        Object.keys(this.studentManagementErrorHash).length === 0
      );
    }
  },

  watch: {
    isValid: {
      handler(val) {
        this.$emit('update:valid', val);
      },
      immediate: true
    }
  },

  methods: {
    onStudentManagementConfigChanged(config, edited = true) {
      this.$emit('update:student-management-config', config, edited);
      this.$emit('changed');
    },

    onStudentManagementConfigValidChanged(valid) {
      this.$emit('update:student-management-config-valid', valid);
    },

    onStudentManagementErrorHashChanged(errorHash) {
      this.$emit('update:student-management-error-hash', errorHash);
    },

    onStudentManagementFileChanged({ event, file, index }) {
      if (!event?.target?.files?.length) {
        return;
      }

      const selectedFile = event.target.files[0];
      const filename = selectedFile.name;
      const fileType = selectedFile.type;
      const extensionType = filename.split('.').pop();

      if (
        this.studentManagementFileExtensions.indexOf(extensionType) < 0 ||
        !this.studentManagementFileMimeTypeAllowed.includes(fileType)
      ) {
        event.target.value = '';
        return;
      }

      const nextFiles = this.studentManagementFiles.map((entry, entryIndex) => {
        if (entryIndex !== index) {
          return entry;
        }
        return {
          ...entry,
          file: selectedFile,
          filename: selectedFile.name
        };
      });

      this.$emit('update:student-management-files', nextFiles);
      this.$emit('changed');
    },

    async testConnectionBeforeSave() {
      if (this.moduleName !== 'wonde') {
        return true;
      }
      if (this.$refs.wondeConfig?.testConnectionBeforeSave) {
        return this.$refs.wondeConfig.testConnectionBeforeSave();
      }
      return true;
    }
  }
};
</script>
